import DOMPurify from "dompurify";

// Lazily created server-side instance — reused across calls.
let _serverPurify: ReturnType<typeof DOMPurify> | null = null;

function getServerPurify(): ReturnType<typeof DOMPurify> {
  if (!_serverPurify) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { JSDOM } = require("jsdom") as typeof import("jsdom");
    _serverPurify = DOMPurify(new JSDOM("").window as unknown as Window & typeof globalThis);
  }
  return _serverPurify;
}

export function sanitizeHTML(dirtyHTML: string): string {
  if (typeof window !== "undefined") {
    // Browser: DOMPurify already has access to the native DOM.
    return DOMPurify.sanitize(dirtyHTML);
  }
  // Node.js server: provide a DOM environment via jsdom.
  // The require() call is in a dead branch for browser builds,
  // so esbuild/Rollup removes jsdom from the client bundle entirely.
  return getServerPurify().sanitize(dirtyHTML);
}

const STRIP_ALL: Parameters<typeof DOMPurify.sanitize>[1] = { ALLOWED_TAGS: [], ALLOWED_ATTR: [] };

// For plain-text inputs (search boxes, etc.) — strips all HTML, keeps text content.
export function sanitizeInput(value: string): string {
  if (typeof window !== "undefined") {
    return DOMPurify.sanitize(value, STRIP_ALL);
  }
  return getServerPurify().sanitize(value, STRIP_ALL);
}
